import m from "../../../../geodata/es2015/region/world/centralAmericaHigh";
window.am4geodata_region_world_centralAmericaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/centralAmericaHigh.js
// module id = null
// module chunks = 